import React from 'react';
import { useDialog, DialogProvider } from './context.js';
import isFunction from '../../utils/isFunction.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';

const DialogPopup = _ref => {
  let {
    accessibleTrapProps,
    alignment,
    anchor,
    children,
    defaultOpen,
    id,
    mobile,
    onOpenChange,
    open,
    popupSx,
    portaled,
    side
  } = _ref;
  const internalAnchor = React.useRef(null);

  // Setup context values
  const context = useDialog({
    accessibleTrapProps,
    defaultOpen,
    id,
    onOpenChange,
    open,
    mobile,
    popupProps: {
      anchor: anchor || internalAnchor?.current,
      alignment,
      side,
      sx: popupSx
    },
    portaled,
    type: "popup"
  });
  const {
    toggle,
    isOpen
  } = context;
  const triggerProps = {
    "aria-haspopup": "dialog",
    onClick: toggle,
    ref: internalAnchor,
    type: "button"
  };
  const dialogChildren = isFunction(children) ? children({
    isOpen,
    toggle,
    triggerProps
  }) : children;
  return jsx(DialogProvider, {
    value: context
  }, dialogChildren);
};
DialogPopup.displayName = "DialogPopup";

export { DialogPopup };
